import { render, staticRenderFns } from "./LayoutLaboratorioMatrizCatalisadores.vue?vue&type=template&id=8a761d00&"
import script from "./LayoutLaboratorioMatrizCatalisadores.vue?vue&type=script&lang=ts&"
export * from "./LayoutLaboratorioMatrizCatalisadores.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBadge,VIcon,VTab,VTabs})
